export default "__VITE_ASSET__6345cd27__"